import React from 'react';
import { Controller, FieldPath, Control } from 'react-hook-form';

import {
  CheckBoxDateAtFieldControl,
  CheckBoxDateAtFieldControlRequiredProps,
  CheckBoxDateAtFieldControlValue
} from './components/CheckBoxDateAtFieldControl';

interface CheckBoxDateAtFieldRequiredProps<T> {
  control: Control<T>;
  name: FieldPath<T>;
}

function CheckBoxDateAtField<T>({
  control,
  disabled,
  className,
  errorClassName,
  id,
  checkBoxClassName,
  label,
  i18nLabel,
  labelClassName,
  name,
  required
}: CheckBoxDateAtFieldRequiredProps<T> &
  CheckBoxDateAtFieldControlRequiredProps) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <CheckBoxDateAtFieldControl
          value={value as CheckBoxDateAtFieldControlValue}
          error={error?.message}
          disabled={disabled}
          className={className}
          errorClassName={errorClassName}
          id={id}
          checkBoxClassName={checkBoxClassName}
          label={label}
          i18nLabel={i18nLabel}
          labelClassName={labelClassName}
          required={required}
          name={name}
          onChange={onChange}
        />
      )}
    />
  );
}

export default CheckBoxDateAtField;
